// src/judge/useContentStable.ts
//
// Živá data obrazovky rozhodčího (useLiveRace, startovní listina) staví
// při každém snímku nová pole – i když se obsah nezměnil (jen metadata,
// potvrzení zápisu). Odvozené výpočty a efekty (zmrazení nastavení,
// samooprava rozhodčích) se mají řídit obsahem, ne identitou objektů
// (docs/live-faze3-navrh.md bod 5.3): hook vrátí předchozí objekt, dokud
// se obsah (JSON) nezmění.

import { useRef } from "react";

export function useContentStable<T>(value: T): T {
  const ref = useRef<{ key: string; value: T } | null>(null);
  let key: string;
  try {
    key = JSON.stringify(value);
  } catch {
    // Nesériovatelné (cyklus) – bez stabilizace
    return value;
  }
  if (!ref.current || ref.current.key !== key) ref.current = { key, value };
  return ref.current.value;
}
